// @ts-nocheck
import React from "react";
import Buttons from "../../../../../../base/basicComponents/button";
import {
  ProposedChangeTagDiv,
  UpdateSupportingSectionStatusDiv,
} from "../../../../../../base/basicComponents/status";
import UploadFile from "../../../../../../base/basicComponents/uploadFile";
import { dataStatus, fileTags, proposedChangeTags } from "../../../../../publicDictionaryValues";
import ApproveProcedureFileTbody from "../../../../procedureFileSections/fields/procedureFileTbodyFields/approveProcedureFileTbody";
import "../index.scss";

export default class ApproveUpdateSupportingFileTbody extends ApproveProcedureFileTbody {
  returnTag = (column: any, rowColumn: any, tagValue: any) => {
    return column.dataName === "status" ? (
      <>
        <UpdateSupportingSectionStatusDiv status={rowColumn.value} tagValue={tagValue} />
      </>
    ) : (
      <>
        <ProposedChangeTagDiv status={rowColumn.value} />
      </>
    );
  };

  /**
   * function about show button if column type is button
   * @param {*} row
   * @param {*} column
   * @param {*} rowIndex
   * @param {*} status
   * @returns
   */
  returnButton = (row: any, column: any, rowIndex: any, status: any) => {
    const { isDisableAllActionButtons = false } = column;
    return (
      <div className="buttonTd-content">
        {/* @ts-ignore */}
        {!this.isHideReplaceBtn && (
          <>
            <Buttons
              color={column.approveColor}
              size="small"
              onClick={(e: any) => column.onApproveClick(e.target.attributes.rowindex.value)}
              disabled={row.isApproveDisabled || isDisableAllActionButtons}
              rowindex={rowIndex}
              testid={`approve-supporting-file-approve-btn-${rowIndex}`}
            >
              {column.approveText}
            </Buttons>
            <UploadFile
              fileInputRef={row.replaceRef}
              isMultiple={false}
              handleFileSelect={this.props.handleFileSelect}
              rowindex={rowIndex}
              isSupportingFile={false}
            />
          </>
        )}
        {/* @ts-ignore */}
        {!this.isHideDeleteBtn && (
          <Buttons
            color={column.returnColor}
            size="small"
            onClick={() => column.onReturnClick(rowIndex)}
            disabled={row.isReturnDisabled || isDisableAllActionButtons}
            rowindex={rowIndex}
            testid={`approve-supporting-file-return-btn-${rowIndex}`}
          >
            {column.returnText}
          </Buttons>
        )}
      </div>
    );
  };

  /**
   * function about control the replace and delete buttons show in revise page
   * @param {*} row
   */
  judgeIsShowReplaceAndDeleteBtn = (row: any) => {
    const fileNameData = row.data.find((item: any) => item.name === "fileName");
    const tagValue = fileNameData && fileNameData.tagValue;
    const proposedChangeValue = row.data.find((item: any) => item.name === "proposedChange").value;
    const isApprovedBefore =
      row.data.find((item: any) => item.name === "previousStatus").value === dataStatus.approval;
    // @ts-ignore
    this.isHideReplaceBtn =
      (tagValue === fileTags.deleted && proposedChangeValue === proposedChangeTags.new) ||
      isApprovedBefore ||
      (proposedChangeValue === null && tagValue === null);
    // @ts-ignore
    this.isHideDeleteBtn =
      (tagValue === fileTags.deleted && proposedChangeValue === proposedChangeTags.new) ||
      isApprovedBefore ||
      (proposedChangeValue === null && tagValue === null);
  };

  render() {
    const {
      data,
      columns,
      procedureNoteMaxLength,
      fileSectionDisabled,
      optionList,
      isShowReturnReason,
      currentRole,
    } = this.props;

    const typeToClassName = {
      link: "linkTd",
      input: "inputTd",
      default: "textTd",
      tag: "tagTd",
      select: "selectTd",
      button: "buttonTd",
      fileName: "fileNameTd",
    };
    return (
      <>
        <tbody className="update-tbody">
          {data.map((row: any, rowIndex: any) => {
            const fileNameData = row.data.find((item: any) => item.name === "fileName");
            const status = row.data.find((item: any) => item.name === "status");
            fileNameData &&
              (status || fileNameData.tagValue) &&
              this.judgeIsShowReplaceAndDeleteBtn(row);
            return (
              <tr
                key={row.data.find((item: any) => item.name === "lineId").value}
                className={`table-tr ${this.returnTrErrorClass(row)}`}
                id={`table-tr-${rowIndex}`}
                data-highlight-id={`file-${row.data.find((item: any) => item.name === "fileId").value}`}
              >
                {columns.map((column: any, columnIndex: any) => {
                  if (!column.isShow) {
                    return;
                  }
                  const rowColumn = row.data.find((x: any) => x.name === column.dataName);

                  const tagValue = row.data.find((x: any) => x.name === "fileName").tagValue;
                  if (column.type === "checkbox") {
                    return this.returnCheckBox(column, row);
                  } else {
                    return (
                      // @ts-ignore
                      <td
                        key={column.dataName}
                        style={{
                          display: this.columnShowStyle(column),
                        }}
                        className={`${typeToClassName[column.type] || typeToClassName.default} ${column.dataName === "proposedChange" ? "proposedChangeTd" : ""}`}
                      >
                        {column.type === "link" &&
                          this.returnLink(rowColumn, column, rowIndex, row)}
                        {column.type === "fileName" && this.returnFileName(rowColumn, column, row)}
                        {/* @ts-ignore */}
                        {column.type === "input" &&
                          this.returnInput(
                            row,
                            rowColumn,
                            column,
                            rowIndex,
                            isShowReturnReason,
                            procedureNoteMaxLength,
                            fileSectionDisabled
                          )}
                        {column.type === "select" &&
                          this.returnSelect(
                            currentRole,
                            rowColumn,
                            column,
                            row,
                            rowIndex,
                            optionList
                          )}
                        {column.type === "button" &&
                          this.returnButton(row, column, rowIndex, status)}
                        {column.type === "tag" && this.returnTag(column, rowColumn, tagValue)}
                        {this.judgeIsShowText(column) && rowColumn.value}
                      </td>
                    );
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </>
    );
  }
}
